require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-tallegg-tvc.json") })
        }
      }, "path---projects-tallegg-tvc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-tallegg-tvc!./.cache/json/projects-tallegg-tvc.json
// module id = 592
// module chunks = 231608221292675